module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-Black.f97e4763.ttf";